const BLOCK_2: RegExp[] = [/\d/, /\d/];
const BLOCK_3: RegExp[] = [/\d/, /\d/, /\d/];

const BLOCK_2_ALPHA: RegExp[] = [/[A-Z0-9]/i, /[A-Z0-9]/i];
const BLOCK_3_ALPHA: RegExp[] = [/[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i];
const BLOCK_4_ALPHA: RegExp[] = [/[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i];

const CPF_LENGTH: number = 11;

export const cpfMask: (RegExp | string)[] = [
  ...BLOCK_3, '.', ...BLOCK_3, '.', ...BLOCK_3, '-', ...BLOCK_2
];

export const alphanumericCnpjMask: (RegExp | string)[] = [
  ...BLOCK_2_ALPHA, '.', ...BLOCK_3_ALPHA, '.', ...BLOCK_3_ALPHA, '/', ...BLOCK_4_ALPHA, '-', ...BLOCK_2
];

export function cpfCnpjMask(userInput: string): (RegExp | string)[] {
  const cleanedInput = (userInput || '').replace(/[^A-Z0-9]/gi, '');

  return cleanedInput.length <= CPF_LENGTH ? cpfMask : alphanumericCnpjMask;
}
